import { createAsyncThunk } from '@reduxjs/toolkit';
import { API } from '../../network/api';
import UserPermissions from 'types/rbac';
import { RizeUser } from 'types/common';

type Credentials = {
  emailId: string;
  password: string;
};

type LoginResponse = {
  token: string;
  permissions: UserPermissions;
  user: RizeUser;
};

export const login = createAsyncThunk<LoginResponse, Credentials>(
  'auth/login',
  async (credentials, thunkAPI) => {
    try {
      const response = await API.post<LoginResponse>(
        '/auth/login',
        credentials,
      );
      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const verify = createAsyncThunk(
  'auth/verify',
  async (token, thunkAPI) => {
    try {
      const response = await API.get('/user/verify');
      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
